import { CAUI, ControlButton, ControlButtonContainer } from 'ca-ui';

export class VRControls extends ControlButtonContainer {
  constructor (vr, options) {
    super({});

    console.log('controls initialized');
    this.vr = vr;
    this.options = options;

    this.buttons = [];

    this.el.addClass('ca-vr_roomcontrols');

    this.initControls(false);
  }

  initControls (reInit) {
    this.buttons = [];
    this.zoomControlGroup = $(
      '<div class="ca-vr_roomcontrol ca-vr_control-group ca-vr_control-group_zoom"></div>'
    );
    this.add(this.zoomControlGroup);

    this.zoomInControl = new ControlButton({
      icon: 'search-plus',
      tooltip: 'Zoom in'
    });
    this.zoomControlGroup.append(this.zoomInControl.el);

    this.zoomOutControl = new ControlButton({
      icon: 'search-minus',
      tooltip: 'Zoom out'
    });
    this.zoomControlGroup.append(this.zoomOutControl.el);

    this.zoomInControl.on(
      'click',
      function () {
        this.vr.zoomIn(2000);
      }.bind(this)
    );

    this.zoomOutControl.on(
      'click',
      function () {
        this.vr.zoomOut(2000);
      }.bind(this)
    );

    this.buttons.push(this.zoomControlGroup);
    this.buttons.push(this.zoomInControl);
    this.buttons.push(this.zoomOutControl);

    if (!this.options.controls.includes('zoom') || this.options.minHfov !== undefined || this.options.minHfov !== this.options.maxHfov || this.vr.options.mobile) {
      this.zoomControlGroup.hide();
    }

    // Zoom

    // Day night
    this.dayNightButton = $(
      '<a class="ca-vr_roomcontrol ca-vr_control ca-vr_control_nightday ca-vr_control_daynight fa fas"><span class="ca-vr_control_tooltip">' +
          (this.options.isNight ? 'Day mode' : 'Night mode') +
          '</span></a>'
    );
    this.add(this.dayNightButton);
    this.dayNightButton.addClass(this.options.isNight ? 'fa-sun' : 'fa-moon');

    this.dayNightButton.on(
      'click',
      function () {
        this.dayNightButton.attr('disabled', true);
        this.dayNightButton.css('pointer-events', 'none');

        const day = this.dayNightButton.hasClass('fa-moon');
        this.dayNightButton
          .find('.ca-vr_control_tooltip')
          .text(day ? 'Day mode' : 'Night mode');

        this.vr.toggleDayNight();

        if (day) {
          this.dayNightButton.removeClass('fa-moon').addClass('fa-sun');
        } else this.dayNightButton.removeClass('fa-sun').addClass('fa-moon');
      }.bind(this)
    );

    this.buttons.push(this.dayNightButton);
    if ((!this.options.controls.includes('daynight') && !this.options.editor) || (!this.options.dayNight && !this.options.editor)) {
      this.dayNight.hide();
    }

    // Ambient noise
    this.ambientNoiseButton = $(
      '<a class="ca-vr_roomcontrol ca-vr_control ca-vr_control_ambient ca-vr_control_audio fa fas fa-volume-up"><span class="ca-vr_control_tooltip">Play ambient noise</span></a>'
    );
    this.add(this.ambientNoiseButton);

    let audioElement;
    this.ambientNoiseButton.on(
      'click',
      function () {
        if (this.ambientNoiseButton.hasClass('fa-volume-mute')) {
          this.ambientNoiseButton
            .removeClass('fa-volume-mute')
            .addClass('fa-volume-up');
          audioElement.pause();
        } else {
          this.ambientNoiseButton
            .removeClass('fa-volume-up')
            .addClass('fa-volume-mute');

          if (!audioElement) {
            this.ambientNoiseButton.attr('disabled', true);
            this.ambientNoiseButton.css('pointer-events', 'none');

            audioElement = document.createElement('audio');
            audioElement.addEventListener(
              'canplaythrough',
              function () {
                this.ambientNoiseButton.attr('disabled', false);
                this.ambientNoiseButton.css('pointer-events', 'all');
              }.bind(this),
              false
            );
            audioElement.src =
                'https://ca-v2.s3-ap-southeast-2.amazonaws.com/tfnsw/syd-metro-west/virtual/ver-audio.mp3?v=' +
                this.options.mediaVersion;
            audioElement.loop = true;
            audioElement.load();
          }
          audioElement.play();
        }
      }.bind(this)
    );

    this.buttons.push(this.ambientNoiseButton);
    if (!this.options.controls.includes('ambient') || !this.options.ambient || this.options.mobile) {
      this.ambientNoiseButton.hide();
    }

    // Sharing
    if (
      this.options.hasShare ||
      (this.options.editor && this.options.controls.includes('share'))
    ) {
      this.shareButton = $(
        '<a href="#caVrShareModal" data-ca-modal="inline" class="ca-vr_roomcontrol ca-vr_control ca-vr_control_share fa fas fa-share-alt"><span class="ca-vr_control_tooltip">Social links</span></a>'
      );
      this.add(this.shareButton);

      this.buttons.push(this.shareButton);

      // Share modal
      const sharePanel = $(
        '<div id="caVrShareModal" class="mfp-hide popup-container ca-vr_share-panel"><div class="popup-header bg-primary-gradient"><h2>Follow us on social media</h2></div><div class="popup-body"></div></div>'
      );
      $('body').append(sharePanel);

      const sharePanelBody = sharePanel.find('.popup-body');
      if (this.options.shareFacebook !== undefined) {
        sharePanelBody.append(
          '<a href="' +
            this.options.shareFacebook +
            '" target="_blank" class="ca-vr_share-panel_button ca-vr_share-panel_button-facebook"></a>'
        );
      }
      if (this.options.shareTwitter !== undefined) {
        sharePanelBody.append(
          '<a href="' +
            this.options.shareTwitter +
            '" target="_blank" class="ca-vr_share-panel_button ca-vr_share-panel_button-twitter"></a>'
        );
      }
      if (this.options.shareLinkedIn !== undefined) {
        sharePanelBody.append(
          '<a href="' +
            this.options.shareLinkedIn +
            '" target="_blank" class="ca-vr_share-panel_button ca-vr_share-panel_button-linkedin"></a>'
        );
      }
      if (this.options.shareYouTube !== undefined) {
        sharePanelBody.append(
          '<a href="' +
            this.options.shareYouTube +
            '" target="_blank" class="ca-vr_share-panel_button ca-vr_share-panel_button-youtube"></a>'
        );
      }
      if (this.options.shareInstagram !== undefined) {
        sharePanelBody.append(
          '<a href="' +
            this.options.shareInstagram +
            '" target="_blank" class="ca-vr_share-panel_button ca-vr_share-panel_button-instagram"></a>'
        );
      }
    }

    // Welcome
    if (this.options.welcomeLabel === undefined) {
      this.options.welcomeLabel = 'Open Welcome Screen';
    }
    this.welcomeButton = $(
      '<a data-ca-modal="inline" class="ca-vr_roomcontrol ca-vr_control ca-vr_control_welcome fa fas fa-info"><span class="ca-vr_control_tooltip">' +
          this.options.welcomeLabel + '</span></a>'
    );
    this.add(this.welcomeButton);

    this.buttons.push(this.welcomeButton);

    this.welcomeButton.unbind();
    this.welcomeButton.on('click', function () {
      this.vr.showWelcome();
    }.bind(this));

    $(this.options.welcomeModal + ' .ca-vr_welcome-enter').on(
      'click',
      function () {
        $.magnificPopup.instance.close();
      }
    );
    if ((this.options.welcomeContent === undefined && !this.options.controls.includes('welcome')) || (this.options.welcomeContent === null && !this.options.controls.includes('welcome')) || !this.options.controls.includes('welcome')) {
      this.welcomeButton.hide();
    }

    // Fullscreen
    this.fullscreenButton = new ControlButton({
      icon: 'expand',
      tooltip: 'Fullscreen',
      tooltipDirection: 'left'
    });
    this.fullscreenButton.el.addClass('ca-vr_control_fullscreen');
    this.add(this.fullscreenButton);
    if (!this.options.allControls || (!this.options.controls.includes('fullscreen') && !this.vr.isFullscreenEnabled())) {
      this.fullscreenButton.hide();
    }
    this.fullscreenButton.on(
      'click touchstart',
      function () {
        CAUI.enterFullscreen(!this.fullscreen, this.vr.wrapper[0]);
        this.fullscreen = !this.fullscreen;

        this.fullscreenButton.setIcon(
          this.fullscreen ? 'compress' : 'expand'
        );
        this.fullscreenButton.setTooltip(
          this.fullscreen ? 'Exit fullscreen' : 'Fullscreen'
        );

        this.vr.update();
      }.bind(this)
    );

    this.buttons.push(this.fullscreenButton);

    // Vr
    if (navigator.xr) {
      this.vrButton = new ControlButton({
        icon: 'vr-cardboard',
        tooltip: 'Start VR',
        tooltipDirection: 'left'
      });
      this.add(this.vrButton);

      this.vrButton.on(
        'click',
        function () {
          this.vr.toggleVr();
        }.bind(this)
      );

      this.buttons.push(this.vrButton);
      if (!this.webXrSupported) {
        navigator.xr.isSessionSupported('immersive-vr').then((supported) => {
          this.webXrSupported = supported;
          this.vrButton.toggle(this.webXrSupported);
        });
      } else {
        this.vrButton.toggle(this.webXrSupported);
      }
    }

    // Edit
    if (this.vr.options.caEditor) {
      if (this.vr.editor) {
        const editButtonText = 'Preview Room in Editor';
        this.editButton = $(
          `<a style="display: flex !important" data-ca-modal="inline" class="ca-vr_roomcontrol ca-vr_control ca-vr_control_edit fa fas fa-pen"><span class="ca-vr_control_tooltip">${editButtonText}</span></a>`
        );
        this.add(this.editButton);

        this.editButton.on(
          'click',
          function () {
            this.vr.toggleEditor();
            if (this.vr.editor.editing) {
              $('.ca-vr_control_edit span.ca-vr_control_tooltip').text($('.ca-vr_control_edit span.ca-vr_control_tooltip').text().replace('Edit Room', 'Preview Room in Editor'));
            } else {
              $('.ca-vr_control_edit span.ca-vr_control_tooltip').text($('.ca-vr_control_edit span.ca-vr_control_tooltip').text().replace('Preview Room in Editor', 'Edit Room'));
            }
          }.bind(this)
        );
        this.buttons.push(this.editButton);
      }
    }

    if (reInit) this.showControls(true);
  }

  showControls (show) {
    if (show) super.show();
    else super.hide();

    this.buttons.forEach(function (c) {
      c.css('opacity', show ? '1' : '0');
      c.css('pointer-events', show ? 'all' : 'none');
    });

    $('.ca-vr_hideonmodal').css('opacity', show ? '1' : '0');
    // if(zoomControlGroup != undefined) zoomControlGroup.css('pointer-events', show ? 'all' : 'none');
  }

  toggleIndividualControl (control, toggleStatus) {
    this.buttons.forEach(function (button) {
      if ((button[0] && button[0].classList.contains(`ca-vr_control-group_${control}`)) || (button[0] && button[0].classList.contains(`ca-vr_control_${control}`)) ||
      (button.el !== undefined && button.el[0] !== undefined && button.el[0].classList.contains(`ca-vr_control_${control}`))) {
        if (!toggleStatus) {
          button.el !== undefined ? button.el.hide() : button.hide();
        } else {
          button.el !== undefined ? button.el.show() : $(button).show();
        }
      }
    });
  }
}
